export const MENU_OPTIONS = [
  {
    name: "Início",
    icon: "fa-light fa-house",
    route: { name: "home" }
  },
  {
    name: "Produtos",
    icon: "fa-light fa-cube",
    context: "products",
    indicator: "/produto/",
    permissions: ["gerenciar-produtos"],
    options: [
      // {
      //   name: "Novo produto",
      //   route: { name: "product-new" }
      // },
      {
        name: "Meus produtos",
        route: { name: "product" }
      }
    ]
  },
  {
    name: "Próximos lançamentos",
    icon: "fa-light fa-rocket",
    route: { name: "releases" },
    indicator: "/próximos-lançamentos/",
    permissions: ["proximos-lancamentos"]
  },
  {
    name: "Saldo",
    permissions: ["ver-extrato"],
    icon: "fa-light fa-wallet",
    route: { name: "balance" },
    indicator: "/saldo/"
  },
  {
    name: "Indique & Ganhe",
    custom: true,
    permissions: ["indique-e-ganhe"]
  },
  {
    name: "Ferramentas",
    icon: "fa-light fa-tools",
    indicator: "/ferramentas/",
    route: { name: "tools" },
    permissions: [
      "coproducoes",
      "central-de-colaboradores",
      "api-e-notificacoes",
      "webhook-api-e-notificacoes",
      "lead-list",
      "e-mail-marketing",
      "automacoes",
      "notas-fiscais",
      "kajabi",
      "zoom",
      "certificacoes-mec",
      "pixel-de-rastreamento",
      "integracoes"
    ]
  },
  {
    name: "Vendas",
    icon: "fa-light fa-cart-shopping",
    indicator: "/vendas/",
    context: "sales",
    options: [
      {
        name: "Visão geral",
        route: { name: "sales" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Assinaturas",
        route: { name: "sales-subscriptions" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Cursos",
        route: { name: "sales-courses" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Eventos",
        route: { name: "sales-events" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Recuperação de vendas",
        route: { name: "sales-recovery" },
        permissions: ["acessar-vendas"]
      },
      {
        name: "Vendas presenciais",
        route: { name: "card-machine" },
        permissions: ["acessar-vendas"]
      }
    ],
    permissions: ["acessar-vendas"]
  },
  {
    name: "Gestão de assinaturas",
    icon: "fa-light fa-arrows-spin",
    route: { name: "subscriptions-manager" },
    permissions: ["gerenciar-assinaturas"]
  },
  {
    name: "Relatórios",
    icon: "fa-light fa-chart-simple",
    context: "reports",
    indicator: "/relatorios/",
    options: [
      {
        name: "Clientes",
        route: { name: "reports-clients" },
        permissions: ["clientes"]
      }
    ],
    permissions: ["clientes"]
  }
];
